
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelClimate from "@/views/评测管理/model/DZModelClimate";
import DZModelDicConfig from "@/model/DZModelDicConfig";

@Component
export default class Climate extends Vue{

  @Prop() data;

  @Prop() dic;

  flag = true
  handle_edit(){
    this.flag = !this.flag
  }

  m_climate = new DZModelClimate();

  formData = {
    climateType:[],
    sunlightDuration:[],
    sunshineRate:[],
    averageTemperature:[],
    frostfreePeriod:[],
    rainfall:[],
    humidity:[]
  }

  arr = ['climateType', 'sunlightDuration', 'sunshineRate', 'averageTemperature',
  'frostfreePeriod', 'rainfall', 'humidity']

  dic_config = new DZModelDicConfig();

  mounted() { }

  @Watch("data")
  watchData(value: any, oldValue: string){
    if(value){
      this.m_climate = value
    }
  }

  @Watch("dic")
  watchDic(value: any, oldValue: string) {
    if(value){
      let idList = []
      this.arr.forEach( a =>{
        idList.push(this.dic_config.get(a))
      })
      value.forEach( d =>{
        let index = idList.indexOf(d.typeId)
        if (index != -1) {
          this.formData[this.arr[index]] = d.dicList
        }
      })
      this.$forceUpdate()
    }
  }

  handle_submit(){
    this.$emit('ny_submit_climate', this.m_climate)
    this.handle_edit()
  }
}
